import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  useCallback,
} from "react";
import { useOrgData } from "state/OrgDataContext";

const PrefNavigatorContext = createContext();

export function PrefNavigatorProvider({ children }) {
  const { dataContent: EVENT_CONTENT } = useOrgData();
  const [stepsConfig, setStepsConfig] = useState(EVENT_CONTENT.prefSteps || []);
  const [currentStep, setCurrentStep] = useState(null);
  const hasEnabledStep = EVENT_CONTENT.prefSteps?.some((step) => step.enabled);
  const enabledSteps = stepsConfig.filter((step) => step.enabled);

  useEffect(() => {
    const firstEnabledStep = stepsConfig.find((step) => step.enabled);
    if (firstEnabledStep) {
      setCurrentStep(firstEnabledStep.step);
    }
  }, [stepsConfig]);

  const getNextStepName = useCallback(() => {
    const currentIndex = stepsConfig.findIndex(
      (step) => step.step === currentStep
    );
    const nextEnabledStep = stepsConfig
      .slice(currentIndex + 1)
      .find((step) => step.enabled);
    return nextEnabledStep ? nextEnabledStep.step : null;
  }, [currentStep, stepsConfig]);

  const getPreviousStepName = useCallback(
    (currentStep) => {
      const currentIndex = stepsConfig.findIndex(
        (step) => step.step === currentStep
      );
      const previousEnabledStep = stepsConfig
        .slice(0, currentIndex)
        .reverse()
        .find((step) => step.enabled);
      return previousEnabledStep ? previousEnabledStep.step : null;
    },
    [stepsConfig]
  );

  const calculateProgressValues = () => {
    const enabledSteps = stepsConfig.filter((step) => step.enabled);
    const currentStepIndex = enabledSteps.findIndex(
      (step) => step.step === currentStep
    );
    return enabledSteps.map((_, index) =>
      index <= currentStepIndex ? 100 : 0
    );
  };

  const progressBarValues = calculateProgressValues();

  const contextValue = {
    stepsConfig,
    setStepsConfig,
    currentStep,
    setCurrentStep,
    getNextStepName,
    getPreviousStepName,
    hasEnabledStep,
    enabledSteps,
    progressBarValues,
  };

  return (
    <PrefNavigatorContext.Provider value={contextValue}>
      {children}
    </PrefNavigatorContext.Provider>
  );
}

export const usePrefNavigator = () => useContext(PrefNavigatorContext);
